'use client';
import { isSmartLookSupported } from '@/libs/smartlook/check-smart-look-support';
import Script from 'next/script';
import { useEffect, useState } from 'react';

const SmartLookScript = () => {
  const enableSmartLook = process.env.NEXT_PUBLIC_SMART_LOOK;

  const [isSupported, setIsSupported] = useState(false);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setIsSupported(isSmartLookSupported());
    }
  }, []);

  if (!enableSmartLook || !isSupported) return null;

  return (
    <Script
      strategy="afterInteractive"
      id="smartlook"
      dangerouslySetInnerHTML={{
        __html: `
       (function(d) {
    var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
    var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';
    c.charset='utf-8';c.src='https://web-sdk.smartlook.com/recorder.js';h.appendChild(c);
    })(document);
    smartlook('init', '256d92d52190eaf2057cd83d91b67774a3ef7f58', { region: 'eu' });`,
      }}
    />
  );
};

export default SmartLookScript;
